import axiosInstance from 'api/axiosInstance'

export type GetFansGroupsParams = {
    search?: string
    sort_by?: 'name' | 'number_of_fans' | 'date_added'
    sort_order?: 'asc' | 'desc'
    post_id?: string
}

export const getFansGroups = async (
    params: GetFansGroupsParams = {}
) => {
    const { data } = await axiosInstance({
        method: 'GET',
        url: '/api/user/groups',
        params: {
            search: params.search || undefined,
            sort_by: params.sort_by || undefined,
            sort_order: params.sort_order || undefined,
            post_id: params.post_id || undefined
        }
    })

    return data?.data
}

export const createFansGroup = async (name: string) => {
    const { data } = await axiosInstance({
        method: 'POST',
        url: '/api/user/create_group',
        data: {
            name,
            participants: []
        }
    })
    return data
}

export const editFansGroup = async (
  groupId: string | null,
  updatedData: { participants?: string[] | null; name: string }
) => {
  if (groupId == null) {
    throw new Error('editFansGroup: groupId is required')
  }

  const { data } = await axiosInstance({
    method: 'PUT',
    url: `/api/user/update_group/${groupId}`,
    data: updatedData
  })
  return data
}

export const deleteFansGroup = async (id: string) => {
    const { data } = await axiosInstance({
        method: 'DELETE',
        url: `/api/user/group/${id}`
    })
    return data
}

export const getUsersFromFansGroup = async (
  id: string | null,
  params: Record<string, any> = {}
) => {
  const { data } = await axiosInstance({
    method: 'GET',
    url: `/api/user/group/${id}`,
    params
  })

  return data?.data ?? {
    group: null,
    users: []
  }
}
// eslint-disable-next-line @typescript-eslint/ban-types
export const getUserFans = async (params: {}) => {
    const { data } = await axiosInstance({
        method: 'GET',
        url: '/api/user/get-fans',
        params
    })
    return data?.data
}

export const addFanToGroups = async (
    userId: string,
    groupIds: string[] | number[]
) => {
    const { data } = await axiosInstance({
        method: 'POST',
        url: `/api/user/${userId}/add-groups-to-user`,
        data: { groups: groupIds }
    })

    return data
}

export const getGroupsFromFan = async (id: string) => {
    const { data } = await axiosInstance({
        method: 'GET',
        url: `/api/user/subscriber/groups/${id}`
    })

    return data?.data
}
